import dayjs from 'dayjs';
import { AnomalyDirection, Period } from '../../types';

export const failureCondition = (value: any, payload: any) =>
  (payload?.is_anomalous !== undefined && payload?.is_anomalous) ||
  (payload?.is_anomalous === undefined &&
    ((value > payload.max_value &&
      (!payload?.anomaly_direction ||
        payload.anomaly_direction === AnomalyDirection.Both ||
        payload.anomaly_direction === AnomalyDirection.Spike)) ||
      (value < payload.min_value &&
        (!payload?.anomaly_direction ||
          payload.anomaly_direction === AnomalyDirection.Both ||
          payload.anomaly_direction === AnomalyDirection.Drop)))) ||
  (payload?.fail_on_zero && value === 0);

export const isInDetectionPeriod = (
  detectionPeriod?: Period,
  endTime?: string,
  latestRunTime?: string,
) => {
  if (!detectionPeriod) return false;

  const diff = dayjs(latestRunTime).diff(endTime, detectionPeriod.period, true);
  return diff >= 0 && diff <= detectionPeriod.count;
};

export const isFailurePoint = (data: {
  value: number;
  min_value?: number | null;
  max_value?: number | null;
}) =>
  (data.min_value != null || data.max_value != null) &&
  failureCondition(data.value, data);
